import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { IPolicyDateRange } from '../shared/models/policies.interface';

@Injectable({
  providedIn: 'root'
})
export class PolicyDateRangeService {
  getPolicyDateRange(): IPolicyDateRange | null {


    const policyDetailsRaw = sessionStorage.getItem('policyDetails');
    if (!policyDetailsRaw) {
      return null!;
    }

    const policyDetails = JSON.parse(policyDetailsRaw);
    if (!policyDetails?.effectiveDate || !policyDetails?.expirationDate) {
      return null!;
    }

    try {
      const expirationDate = (policyDetails.cancellationDate
        && new Date(policyDetails.cancellationDate) < new Date(policyDetails.expirationDate))
        ? policyDetails.cancellationDate
        : policyDetails.expirationDate;

      return {
        effectiveDate: policyDetails.effectiveDate,
        expirationDate
      };
    } catch {
      return {
        effectiveDate: policyDetails.effectiveDate,
        expirationDate: policyDetails.expirationDate
      };
    }
  }

  private toLocalPolicyDate(value: string | Date | null | undefined): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/.exec(value);
    if (dateOnlyMatch) {
      const year = Number(dateOnlyMatch[1]);
      const monthIndex = Number(dateOnlyMatch[2]) - 1;
      const day = Number(dateOnlyMatch[3]);
      return new Date(year, monthIndex, day);
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  isCurrentDateWithinPolicyRange(): boolean {
    let policyStartDate: Date | null;
    let policyEndDate: Date | null;

    const policyDateRange = this.getPolicyDateRange();
    if (!policyDateRange) {
      return false;
    } else {
      policyStartDate = this.toLocalPolicyDate(policyDateRange.effectiveDate);
      policyEndDate = this.toLocalPolicyDate(policyDateRange.expirationDate);
    }

    if (!policyStartDate || !policyEndDate) {
      return false;
    }

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    policyStartDate.setHours(0, 0, 0, 0);
    policyEndDate.setHours(0, 0, 0, 0);

    return currentDate >= policyStartDate && currentDate <= policyEndDate;
  }
}